const IS_PROD = window.location.hostname === 'greenlight.ivn-works.com';

export const MAGENTO_BASE_URL = IS_PROD
  ? 'https://bigrigworld.com/catalog/product/view/id/'
  : 'https://hyvadev.bigrigworld.com/catalog/product/view/id/';

export const NS_BASE_URL = IS_PROD
  ? 'https://7535566.app.netsuite.com/app/common/item/item.nl?id='
  : 'https://7535566-sb1.app.netsuite.com/app/common/item/item.nl?id=';
